(() => {
  // --- only run on the cart page ---
  if (!window.location.pathname.startsWith('/cart')) return;

  const MSG_SELECTOR = '.upsell-message';
  const BANNER_SELECTOR = '.upsell-banner';
  const SECTION_HANDLE = window.cartSectionId;


  // --- update banner text ---
  function updateBanner(cart) {
    const MSG = document.querySelector(MSG_SELECTOR);
    const BANNER = document.querySelector(BANNER_SELECTOR);
    if (!MSG || !BANNER) return;

    const TARGET = Number(BANNER.dataset.freeShippingTarget || window.freeShippingTarget || 150);

    const total = (cart?.total_price || 0) / 100;
    const hasItems = cart?.item_count > 0;

    if (!hasItems || total <= 0) {
      BANNER.style.display = 'none';
      return;
    }

    BANNER.style.display = 'block';
    const remaining = TARGET - total;
    const newText =
      remaining > 0
        ? `Add items worth £${remaining.toFixed(2)} for free delivery!`
        : `Eligible for Free Delivery!`;
    const upsellLink = document.querySelector('.upsell-link');
    if (upsellLink) {
      if (remaining <= 0) {
        upsellLink.style.display = 'none';
      } else {
        upsellLink.style.display = 'inline-block';
      }
    }    

    if (MSG.textContent.trim() === newText.trim()) return;
    MSG.style.opacity = 0;
    setTimeout(() => {
      MSG.textContent = newText;
      BANNER.classList.toggle('reached', remaining <= 0);
      MSG.style.opacity = 1;
    }, 150);
  }

  // --- refresh upsell section ---
  function refreshUpsell() {
    console.log('[Upsell Refresh] fetching /?section_id=' + SECTION_HANDLE);
    fetch(`/?section_id=${SECTION_HANDLE}`)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const upsell = document.querySelector('[id^="UpsellSection-"]');
        const updated = doc.querySelector('[id^="UpsellSection-"]');

        if (updated) {
          const updatedContainer =
            updated.parentElement?.classList.contains('page-width') ? updated.parentElement : updated;

          if (upsell) {
            const currentContainer =
              upsell.parentElement?.classList.contains('page-width') ? upsell.parentElement : upsell;
            currentContainer.replaceWith(updatedContainer);
            console.log('[Upsell Refresh] replaced');
            return;
          }

          const cartSection = document.querySelector('.cart.section');
          if (cartSection) {
            cartSection.append(updatedContainer);
            console.log('[Upsell Refresh] inserted');
          }
        } else {
          const currentContainer =
            upsell && upsell.parentElement?.classList.contains('page-width') ? upsell.parentElement : upsell;
          currentContainer?.remove();
          console.warn('[Upsell Refresh] section not found in fetched HTML');
        }
      })
      .catch(err => console.warn('[Upsell Refresh] fetch failed', err));
  }

  // --- cart fetch/update ---
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(updateBanner)
      .catch(() => console.warn('[Free Shipping] Failed to fetch cart.'));
  }

  // --- ensure banner exists before running ---
  function waitForBannerAndRun() {
    const banner = document.querySelector(BANNER_SELECTOR);
    if (!banner) return setTimeout(waitForBannerAndRun, 200);
    fetchCartAndUpdate();
  }

  // --- event bindings ---
  document.addEventListener('DOMContentLoaded', waitForBannerAndRun);
  document.addEventListener('page:loaded', waitForBannerAndRun);

  // only trigger refreshes when we’re on cart page
  document.addEventListener('ajaxProduct:added', () => {
    if (window.location.pathname.startsWith('/cart')) {
      fetchCartAndUpdate();
      refreshUpsell();
    }
  });

  document.addEventListener('cart:updated', e => {
    if (window.location.pathname.startsWith('/cart')) {
      updateBanner(e.detail.cart);
      refreshUpsell();
    }
  });
})();
